export const STEP = {
    // Intro

    START: 0,

    INTRO: 1,

    
    

    COMPLETE: 999,
} as const;

export const TUTORIAL_STEPS = [
    {
        id: "welcome",
        text: `Welcome to the tutorial for the last year of carbon!`,
    },

    {
        id: "show_player_mat",
        text: `Here's your playermat, a physical representation of your company`,
        show: ["player_mat"],
    },

    {
        id: "buy_battery",
        text: `Click the "buy" button over the battery space`,
        highlight: "battery_buy_button",
        waitFor: "battery_purchased",
    },
];

export const TUTORIAL_BLURBS = [
// 0
`Welcome to the tutorial for
the last year of carbon!`,

//1
`Let's go over:

-Mats
-Pieces
-Card Types
-How Turns Work

Then you'll be free to play the rest of this game!`,

// 2
`Like the name implies,
the Last Year of Carbon
takes place over the course
of a singular calendar year`,

// 3
`Each month is 1 turn in this game.

You will play 3 months, then have a Summit to see how everyone's doing.
That is the structure of 1 Season.

There will be 4 Seasons in the game.

Spring, Summer, Fall, Winter.`,

// 4 - const name
`This is the table where the game will be played.
Drag, pinch, scroll, zoom, check it out`,

// 5
`This is the central mat. It keeps track of:
-what month we're in
-what season we're in
-how much energy we need to donate this season

I'll keep track of this info in the upper left, too.`,

// 6 
`You are a renewable energy company and boy what good timing.
This is the last year any non-renewable energy is left on this planet (oil, gas, etc).`,

// 7 - carbonDrop
`There it goes! 25 pieces left in the Carbon Reserve`,

// 8 
`That's all of it. If we run out of those, everybody loses.
You can keep track of how much is left in the upper left.`,

// 9
`It is your job to make your renewable energy company
donate energy to keep the world going.`,

`Each turn you will:

- donate energy
- make your company better
- make someone else's company worse`,

`Here's your playermat, a physical representation 
of your renewable energy company`,

`There's places all over it to keep track of how well
(or poorly) you are doing`,

`These are factories, each of these produces 1 energy a month`,

`A month starts when a new news card shows up.

New news card -> new month -> new energy on your factories

You can click on cards to get a better look at them`,

`Batteries store energy.

Let's buy one now.`,

`Click the "buy" button over the battery space`,
`Toss in 1 energy into the box below the "Pay Here" sign, then click pay.

If you miss that's fine, just hit cancel and try to buy it again`,

`1 battery can store 1 energy.

If you need to steal an energy from somewhere, it goes on one of your empty batteries.

If you don't have an empty battery, no energy for you.`,

`Trying storing an energy on a battery by clicking the "store" button`,

`Incredible, you're a natural.`,

`Oh sick, we got a card!

Click on the card that just appeared to get a closer look`,

`This is your hand. You'll be able to see all of your seasonal cards here.
(Most) cards have their cost in the upper right hand corner.

This is a PR card. PR Cards are Pink. Let's buy it. Click "Play Card"`,

`PR keeps track of how popular your company is in the public eye.

You can buy PR on your turn directly from your playermat, 2 energy for 1 PR.

PR Cards cut that cost in half. Nice.`,

`Great! Now you're a little more popular.

PR protects you from bad news cards and from other players.`,

`Let's play the next card that just showed up in your hand.`,

`This is an Event card. Event cards are Green.
The cost is in the upper right hand corner. This one is free, and recharges a battery! Nice!`,

`Let's use this energy to pay for your next card in your hand!`,

`This is an Equipment Card. Equipment cards are red and are permenant buffs. Let's play it.`,

`Super cool, you now get 1 extra card per season! Let's check that one out.`,

`This is an Award. Award cards are yellow and are competitions between you and your neighbors - the players to your left and right.
The winner of the competition gets a prize at the end of the Season, also called the Summit.`,

`The next card in your hand is a Contract. Let's play this one too`,

`Contracts (Blue) are cards that give you up front Funding.
You must achieve the Goal at the due date (upper right) or suffer a penalty.`,

`Contracts and Awards both during Summits. Contracts are pass/fail for each player,
Awards (and their prize) are awarded to the player who won them.`,

`Finally, we have Summit Cards. These are especially powerful.
They are either a boost to play on your turn, or a goal with a reward at the end of the game`,

`Every player gets 1 Summit card at the start of the game,
and another each Summit if they Donate enough energy.`,

`That's the basics of how to play! Here are the other players.
I'm going to turn your lose and let you play the rest of this game.
Click the "End Turn" button to pass your turn, then do your best to build up your company and Donate the most!

Hit me up with compliments or grievances: support@lastyearofcarbon.com`
]


export const tutStep_0 = 0;
export const tutStep_1 = 1;
export const tutStep_2 = 2;
export const tutStep_3 = 3;
export const tutStep_4 = 4;
export const tutStep_5 = 5;
export const tutStep_6 = 6;
export const tutStep_7 = 7;
export const tutStep_8 = 8;
export const tutStep_9 = 9;
export const tutStep_10 = 10;
export const tutStep_11 = 11;
export const tutStep_12 = 12;
export const tutStep_13 = 13;
export const tutStep_14 = 14;
export const tutStep_15 = 15;
export const tutStep_16 = 16;
export const tutStep_17 = 17;
export const tutStep_18 = 18;
export const tutStep_19 = 19;
export const tutStep_20 = 20;
export const tutStep_21 = 21;
export const tutStep_22 = 22;
export const tutStep_23 = 23;
export const tutStep_24 = 24;
export const tutStep_25 = 25;
export const tutStep_26 = 26;
export const tutStep_27 = 27;
export const tutStep_28 = 28;
export const tutStep_29 = 29;
export const tutStep_30 = 30;
export const tutStep_31 = 31;
export const tutStep_32 = 32;
export const tutStep_33 = 33;
export const tutStep_34 = 34;
export const tutStep_35 = 35;
export const tutStep_36 = 36;
export const tutStep_37 = 37;
export const tutStep_38 = 38;
export const tutStep_39 = 39;
export const tutStep_40 = 40;
export const tutStep_41 = 41;
export const tutStep_42 = 42;
export const tutStep_43 = 43;
export const tutStep_44 = 44;
export const tutStep_45 = 45;
export const tutStep_46 = 46;
export const tutStep_47 = 47;
export const tutStep_48 = 48;
export const tutStep_49 = 49;
export const tutStep_50 = 50;